interface TimelineItemProps {
	date: string;
	time: string;
	description: string;
	isActive?: boolean;
}

export function TimelineItem({ date, time, description, isActive }: TimelineItemProps) {
	return (
		<div className="flex gap-4 py-3">
			<div className="w-24 text-sm">
				<div className={isActive ? "font-medium" : "text-gray-500"}>{date}</div>
				<div className="text-gray-500">{time}</div>
			</div>
			<div className={`flex-1 ${isActive ? "font-medium" : "text-gray-500"}`}>
				{description}
			</div>
		</div>
	);
}
